import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
const useChildrenServiceOrdersState = () => React.useContext(Context)
export const useChildrenServiceOrders = () => useChildrenServiceOrdersState()?.serviceOrders || []

const QUERY = gql`
  query ServiceOrders($filter: ServiceOrderFilter) {
    serviceOrders(filter: $filter, limit: 9999, sort: { field: ID, type: ASC }) {
      id
      name
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      scheduling
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
        }
      }
      events {
        id
        eventDate
        status {
          id
          name
          color
        }
        description
      }
      status {
        id
        name
        __typename
      }
      user {
        id
        name
        __typename
      }
      placeId
      place {
        id
        name
        resume
        type
        __typename
      }
      asset {
        id
        name
        __typename
      }
      checklist {
        id
        name
        __typename
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        isNonCompliance
        blockIndex
        documents {
          id
          src
          type
          description
          __typename
        }
        question {
          id
          name
          data
          ordination
          categoryOrdination
          nonComplianceConditions
          documents {
            id
            src
            type
            description
            __typename
          }
          description
          reference
          parentReference
          type {
            id
            name
            __typename
          }
          category {
            id
            name
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`

const ChildrenServiceOrdersLoader = ({ children, id }) => {
  let { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: {
        parentIds: id
      }
    },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrders?.length}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ChildrenServiceOrdersLoader
